import React from 'react';
import PropTypes from 'prop-types';
import BufeContent from './BufeContent';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../BufeTooltips';

const cardStyle = {
  padding: 20
};

const BufeBase = (props) => {
  return (
    <div>
      <div className="animated fadeIn">
        <div className="card">
          <div className="card-header">
            {'Értékesítés '}
            <CustomTooltip text={getTooltip('ertekesites')} id="ertekesitesTT" />
          </div>
          <div className="row" style={cardStyle}>
            <div className="col-md-12">
              <BufeContent {...props} globals={props.globals} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

BufeBase.propTypes = {
  globals: PropTypes.object
};

export default BufeBase;
